import { useClientValue } from "@/hooks/useClientValue";
import { useIsMobile } from "@/hooks/use-mobile";
import { supportsDesktopRoomShortcuts } from "./roomKeyboardShortcutSupport";

const readDeviceSupported = () =>
  supportsDesktopRoomShortcuts(
    navigator,
    window.matchMedia("(hover: hover) and (pointer: fine)").matches,
  );

/**
 * Whether this room has a keyboard whose letters it can point at. False until
 * hydration, so server and client agree; a phone never answers yes, so it
 * neither draws the hints nor offers the switch that turns them on.
 *
 * A phone-sized window is drawn in the room's phone layout whatever its
 * pointer reports — an emulator, a preview, a narrow desktop window — and a
 * letter key has nothing visible to describe there. It is followed as the
 * window is resized, as the layout is.
 */
export function useRoomShortcutsSupported() {
  const device = useClientValue(readDeviceSupported, false);
  const phoneLayout = useIsMobile();
  return device && !phoneLayout;
}
